// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
export const WIKI_REVIEWS = "Centrum recenzi\u00ed";
